module.exports = __webpack_public_path__ + "img/green_130.c9a2293d.png";